// extracted by mini-css-extract-plugin
module.exports = {"yellow":"#FEE500","purple":"#C53FF8","green":"#2EEB28","blue":"#2CC0FF","red":"#EB2828","black":"#000000","gray":"#D3D3D3","white":"#f1f1f1","mobile_responsive_breakpoint":"640"};